// Story 8.10 (ADO-2019), DV-37: the bar on /choose and the HHT pages, as the Figma "Select
// Depot" and HHT frames draw it: the logo, "HHT Orders" with its waiting count (only where
// the HHT workflow applies, server-decided) and the account chip; no search, Browse, depot
// tab, Depots link or cart, and no bottom tab bar. Every other page keeps `SiteHeader`,
// which carries the same "HHT Orders" link (`HhtOrdersLink`, shared markup).
//
// The logo is the way into browsing; a store user who still has to choose goes back to the
// choice screen (the browsing routes would send them there anyway, Story 8.1 AC4/AC5).
// ADO-3749: the top right is the User Menu, fed and laid out as on `SiteHeader` (Figma
// 289:1346 draws it beside "HHT Orders"). Story 18.19 (ADO-4086), AC11: "RBP Shopping List"
// follows "HHT Orders" (moved here from the Select Depot content), only when the server says the
// session takes part, whatever the HHT workflow says; `SiteHeader` carries it too.
import { useState } from 'react';
import { Link } from 'react-router';
import { HhtOrdersLink, RbpShoppingListLink, UserMenu, useHeaderLayout } from '../../design-system';
import { useSessionStore } from '../../auth/useSessionStore';
import { useHhtWaitingCountStore } from '../../hht/useHhtWaitingCountStore';
import { useRbpEligibilityStore } from '../../rbp/useRbpEligibilityStore';
import { CHOOSE_ROUTE, PRODUCTS_ROUTE } from '../../ordering/orderingChoices';
import { requiresOrderingChoice } from '../../ordering/orderingSession';
import { useHeaderUserMenu } from '../Products/useHeaderChrome';
import { RBP_SHOPPING_LIST_ROUTE } from '../Rbp/rbpRoutes';
import styles from './ChooserHeader.module.css';

const HHT_LINK_CLASSES = { link: styles.hhtLink, label: styles.hhtLabel, badge: styles.hhtBadge };
const RBP_LINK_CLASSES = { link: styles.hhtLink, label: styles.hhtLabel };

export function ChooserHeader() {
  const brand = useSessionStore((s) => s.brandConfig);
  const mustChoose = useSessionStore(requiresOrderingChoice);
  // DV-39: the cheap count only, so a failure of the classified details never hides it.
  const hhtApplies = useHhtWaitingCountStore((s) => s.applies);
  const hhtWaitingCount = useHhtWaitingCountStore((s) => s.waitingCount);
  const rbpEligible = useRbpEligibilityStore((s) => s.shoppingList);
  const layout = useHeaderLayout();
  const userMenu = useHeaderUserMenu();
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  return (
    <header className={styles.header} data-themed={brand.themed ? 'true' : undefined}>
      <Link to={mustChoose ? CHOOSE_ROUTE : PRODUCTS_ROUTE} className={styles.logo}>
        <img src={brand.logoUrl} alt={brand.name} className={styles.logoImg} />
      </Link>
      <div className={styles.end}>
        {hhtApplies ? (
          <HhtOrdersLink waitingCount={hhtWaitingCount} classes={HHT_LINK_CLASSES} />
        ) : null}
        {rbpEligible ? (
          <RbpShoppingListLink to={RBP_SHOPPING_LIST_ROUTE} classes={RBP_LINK_CLASSES} />
        ) : null}
        <UserMenu
          className={styles.userMenu}
          layout={layout}
          user={userMenu.user}
          account={userMenu.account}
          onSignOut={userMenu.onSignOut}
          themed={brand.themed}
          open={userMenuOpen}
          onOpenChange={setUserMenuOpen}
        />
      </div>
    </header>
  );
}
